module.exports = __webpack_public_path__ + "img/careers_ricerca3.38dda69e.png";